<template>
  <div class="flexContainer">
    <div class="leadin flexfixed" v-html="store.dataElecYesterday"></div>
    <p class="content">des gestrigen Verbrauchs wurden durch erneuerbare Energien gedeckt.</p>
  </div>
</template>

<script>
import { store } from "../store";

export default {
  data() {
    return {
      store,
    };
  },
  mounted() {
    //console.log("mounted elecYesterday");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
